module.exports = __webpack_public_path__ + "49dee89b5acbc95a8e4d07bf8cf1032a.jpg";